"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    subtitle2ClassNames: function() {
        return subtitle2ClassNames;
    },
    useSubtitle2Styles: function() {
        return useSubtitle2Styles;
    }
});
const _react = require("@griffel/react");
const subtitle2ClassNames = {
    root: 'fui-Subtitle2'
};
const useSubtitle2Styles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}"
    ]
}); //# sourceMappingURL=useSubtitle2Styles.styles.js.map
